import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { DataTablePagination, Hospital, Procedimento } from '@/types/_'
import { getUser, timeout } from '@/utils/common'
import Apis from '@/Apis/_'
import _ from 'lodash'

type Mode = 'CREATE' | 'EDIT'

type SetBackofficeModal = {
  name: string,
  value: boolean,
}

type BackofficeModal = {
  tempoCirurgicoPorProcedimento: boolean,
}
export interface TempoCirurgicoPorProcedimento {
  id?: string,
  procedimentoId: string,
  codigo?: string,
  descricao?: string,
  hospitalId: string,
  medicoId?: string,
  medicoNome?: string,
  tempoCirurgicoMinimoEmMinutos: number,
}

export interface CargaDeTempoCirurgicoParametrizado {
  medicoId: string,
  codigosTuss: string[] | string,
  tempoCirurgicoMinimoEmMinutos: number,
}

@Module({ namespaced: true, name: 'BackofficeTempoCirurgicoPorProcedimentoStore' })
export default class BackofficeTempoCirurgicoPorProcedimentoStore extends VuexModule {
  public hospitais: Hospital[] = []
  public hospitalId: string = ''

  public mode: Mode = 'CREATE'

  public modal: BackofficeModal = {
    tempoCirurgicoPorProcedimento: false,
  }

  @Mutation
  setModal(modal: SetBackofficeModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitais() {
    this.hospitais = []
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setHospitais' })
  async getHospitais() {
    const request = await Apis.Agendamento.SuporteApi.getHospitaisByUserCurrent()
    if (request.success) {
      const data = request.data.map((c: any) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  /** MÉDICOS */
  public medicos: Array<{id: string, nome: string}> = []

  @Mutation
  setMedicos(value: Array<{id: string, nome: string}>) {
    this.medicos = value
  }

  @Mutation
  clearMedicos() {
    this.medicos = []
  }

  @Action
  async getAllMedicosByHospitalId() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllMedicosByHospitalId({
        usuarioId: getUser().profile.sub,
        hospitalId: this.hospitalId,
      })
      if (request.success) this.context.commit('setMedicos', request.data as Array<{ id: string, nome: string}> || [])
      return request
    } catch (error) {
      this.context.commit('setMedicos', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  /** PROCEDIMENTOS */
  public procedimentos: Procedimento[] = []

  @Mutation
  setProcedimentos(value: Procedimento[]) {
    this.procedimentos = value
  }

  @Mutation
  clearProcedimentos() {
    this.procedimentos = []
  }

  @Action
  async getProcedimentos() {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        page: 1,
        // total: 500,
        total: 32767,
        searchText: '',
      }

      const request = await Apis.Agendamento.SuporteApi.getProcedimentoPagedSearch(params)
      if (request.success) this.context.commit('setProcedimentos', request.data.procedimentos as Procedimento[] || [])
      return request
    } catch (error) {
      this.context.commit('setProcedimentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Tempo Cirúrgico Por Procedimento */
  private paginationTempoCirurgicoPorProcedimentoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [10, 25, 50, 100],
  }

  public paginationTempoCirurgicoPorProcedimento: DataTablePagination = { ...this.paginationTempoCirurgicoPorProcedimentoDefault }

  get tempoCirurgicoPorProcedimentoPaginationDefault() {
    return this.paginationTempoCirurgicoPorProcedimento
  }

  private tempoCirurgicoPorProcedimentoDefault: TempoCirurgicoPorProcedimento = {
    id: '',
    procedimentoId: '',
    codigo: '',
    descricao: '',
    hospitalId: '',
    medicoId: '',
    medicoNome: '',
    tempoCirurgicoMinimoEmMinutos: 0,
  }

  private tempoCirurgicoPorProcedimentoListDefault: TempoCirurgicoPorProcedimento[] = []

  public tempoCirurgicoPorProcedimento: TempoCirurgicoPorProcedimento = { ...this.tempoCirurgicoPorProcedimentoDefault }
  public tempoCirurgicoPorProcedimentoList: TempoCirurgicoPorProcedimento[] = [...this.tempoCirurgicoPorProcedimentoListDefault]
  public searchTempoCirurgicoPorProcedimento: string = ''

  @Mutation
  setSearchTempoCirurgicoPorProcedimento(value: string) {
    this.searchTempoCirurgicoPorProcedimento = value
  }

  @Mutation
  setPaginationTempoCirurgicoPorProcedimento(val: DataTablePagination) {
    this.paginationTempoCirurgicoPorProcedimento = val
  }


  @Mutation
  setTempoCirurgicoPorProcedimento(tempoCirurgicoPorProcedimento: TempoCirurgicoPorProcedimento) {
    this.tempoCirurgicoPorProcedimento = { ...tempoCirurgicoPorProcedimento }
  }

  @Mutation
  clearTempoCirurgicoPorProcedimento() {
    this.tempoCirurgicoPorProcedimento = { ...this.tempoCirurgicoPorProcedimentoDefault }
  }

  @Mutation
  setTempoCirurgicoPorProcedimentoList(value: TempoCirurgicoPorProcedimento[]) {
    this.tempoCirurgicoPorProcedimentoList = value
  }

  @Mutation
  clearTempoCirurgicoPorProcedimentoList() {
    this.tempoCirurgicoPorProcedimentoList = [...this.tempoCirurgicoPorProcedimentoListDefault]
  }

  @Action
  async getTempoCirurgicoPorProcedimentoPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationTempoCirurgicoPorProcedimento.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationTempoCirurgicoPorProcedimento.rowsPerPage,
        searchText: this.searchTempoCirurgicoPorProcedimento,
      }

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllProcedimentosTempoCirurgicoHospital(params)

      if (request.success) {
        this.context.commit('setTempoCirurgicoPorProcedimentoList', request.data.procedimentosTempoCirurgicoHospital as TempoCirurgicoPorProcedimento[] || [])
        this.context.commit('setPaginationTempoCirurgicoPorProcedimento', {
          descending: false,
          page: pagination.page || this.paginationTempoCirurgicoPorProcedimento.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationTempoCirurgicoPorProcedimento.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationTempoCirurgicoPorProcedimento.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setTempoCirurgicoPorProcedimentoList', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  private paginationTempoCirurgicoPorProcedimentoMedicoDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [10, 25, 50, 100],
  }

  public paginationTempoCirurgicoPorProcedimentoMedico: DataTablePagination = { ...this.paginationTempoCirurgicoPorProcedimentoMedicoDefault }

  get tempoCirurgicoPorProcedimentoMedicoPaginationDefault() {
    return this.paginationTempoCirurgicoPorProcedimentoMedico
  }

  private tempoCirurgicoPorProcedimentoMedicoListDefault: TempoCirurgicoPorProcedimento[] = []

  public tempoCirurgicoPorProcedimentoMedicoList: TempoCirurgicoPorProcedimento[] = [...this.tempoCirurgicoPorProcedimentoMedicoListDefault]
  public searchTempoCirurgicoPorProcedimentoMedico: string = ''

  @Mutation
  setSearchTempoCirurgicoPorProcedimentoMedico(value: string) {
    this.searchTempoCirurgicoPorProcedimentoMedico = value
  }

  @Mutation
  setPaginationTempoCirurgicoPorProcedimentoMedico(val: DataTablePagination) {
    this.paginationTempoCirurgicoPorProcedimentoMedico = val
  }

  @Mutation
  setTempoCirurgicoPorProcedimentoMedicoList(value: TempoCirurgicoPorProcedimento[]) {
    this.tempoCirurgicoPorProcedimentoMedicoList = value
  }

  @Mutation
  clearTempoCirurgicoPorProcedimentoMedicoList() {
    this.tempoCirurgicoPorProcedimentoMedicoList = [...this.tempoCirurgicoPorProcedimentoMedicoListDefault]
  }

  @Action
  async getTempoCirurgicoPorProcedimentoMedicoPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationTempoCirurgicoPorProcedimentoMedico.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationTempoCirurgicoPorProcedimentoMedico.rowsPerPage,
        searchText: this.searchTempoCirurgicoPorProcedimentoMedico,
      }

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllProcedimentosTempoCirurgicoMedico(params)

      if (request.success) {
        this.context.commit('setTempoCirurgicoPorProcedimentoMedicoList', request.data.procedimentosTempoCirurgicoMedico as TempoCirurgicoPorProcedimento[] || [])
        this.context.commit('setPaginationTempoCirurgicoPorProcedimentoMedico', {
          descending: false,
          page: pagination.page || this.paginationTempoCirurgicoPorProcedimentoMedico.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationTempoCirurgicoPorProcedimentoMedico.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationTempoCirurgicoPorProcedimentoMedico.rowsPerPageItems,
        })
      }

      return request
    } catch (error) {
      this.context.commit('setTempoCirurgicoPorProcedimentoMedicoList', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertProcedimentosTempoCirurgico() {
    const params: TempoCirurgicoPorProcedimento = this.tempoCirurgicoPorProcedimento
    Object.entries(params).forEach(([key, value]) => {
      if (key === 'tempoCirurgicoMinimoEmMinutos' && ['', 0, undefined, null].includes(value)) params[key] = 0
      if (['', null, undefined].includes(value as any)) {
        delete params[key]
      }
    })

    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.upsertProcedimentosTempoCirurgico({ ...params, hospitalId: this.hospitalId })
    return request
  }

  /** TEMPO CIRURGICO PARAMETRIZADO */
  cargaDeTempoCirurgicoParametrizadoDefault: CargaDeTempoCirurgicoParametrizado = {
    medicoId: '',
    codigosTuss: [],
    tempoCirurgicoMinimoEmMinutos: 0,
  }

  cargaDeTempoCirurgicoParametrizado: CargaDeTempoCirurgicoParametrizado = { ...this.cargaDeTempoCirurgicoParametrizadoDefault }

  @Mutation
  clearCargaDeTempoCirurgicoParametrizado() {
    this.cargaDeTempoCirurgicoParametrizado = { ...this.cargaDeTempoCirurgicoParametrizadoDefault }
  }

  @Action
  async cargaTempoCirurgicoParametrizado() {
    try {
      const params: any = { hospitalId: this.hospitalId, ...this.cargaDeTempoCirurgicoParametrizado }
      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
        if (key === 'codigosTuss') params[key] = [...new Set((value as String).split('\n'))]
      })
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cargaTempoCirurgicoParametrizado(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
